webpackJsonp([59],{

/***/ "1QOn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var shopname = 'epoque';
// const shopname = 'map'

var version = 'shengchang';
if (/-test/.test(document.URL)) {
  version = 'ceshi';
}
// const version = 'ceshi'
// const version = 'shengchang'

var config = function config() {
  if (version == 'ceshi') {
    return {
      domainname: 'http://custom-mall-test.epoque.cn',
      router: 'http://custom-mall-api-test.epoque.cn',
      vouchernoApi: 'http://119.23.59.31:8091/',
      routerapi: 'http://custom-mall-api-test.epoque.cn/v1/wechat/oauth/entrance',
      version: version,
      shopname: shopname,
      parturl: 'http://test.epoque.cn/copemate'
    };
  }
  return {
    domainname: 'http://custom-mall.epoque.cn',
    router: 'http://custom-mall-api.epoque.cn',
    vouchernoApi: 'http://office.epoque.cn/api-v1.0/',
    routerapi: 'http://custom-mall-api.epoque.cn/v1/wechat/oauth/entrance',
    version: version,
    shopname: shopname,
    parturl: 'http://custom-partner-api.epoque.cn'
  };
};

/* harmony default export */ __webpack_exports__["a"] = (config());

/***/ }),

/***/ "3pLw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__conf__ = __webpack_require__("1QOn");







/* harmony default export */ __webpack_exports__["a"] = ({
  // get请求
  get: function get(url, params, callback, router) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var resData;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // if(router){
              //   router = false
              // }
              !router && (router = false);
              // if(router){
              //   url = config.router + url
              // }
              !router && (url = __WEBPACK_IMPORTED_MODULE_5__conf__["a" /* default */].router + url);
              _context.prev = 2;
              resData = void 0;
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: params }).then(function (res) {
                resData = res.data;
              }).catch(function (err) {
                console.log(err);
              });

            case 6:
              return _context.abrupt('return', resData);

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](2);

              console.log(_context.t0);
              return _context.abrupt('return', null);

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 9]]);
    }))();
  },

  // post请求
  post: function post(url, params, callback, router) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var resData;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              !router && (router = false);
              !router && (url = __WEBPACK_IMPORTED_MODULE_5__conf__["a" /* default */].router + url);
              _context2.prev = 2;
              resData = void 0;
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(params)).then(function (res) {
                resData = res.data;
                if (callback) {
                  callback(res.data);
                }
                // console.log(resData)
              }).catch(function (err) {
                console.log(err);
              });

            case 6:
              return _context2.abrupt('return', resData);

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2['catch'](2);

              console.log(_context2.t0);
              _this2.$store.state.storeforload = false;
              return _context2.abrupt('return', null);

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[2, 9]]);
    }))();
  },

  // jsonGet请求
  jsonGet: function jsonGet(url, callback) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (url) {
                _context3.next = 3;
                break;
              }

              console.error('Axios.JSONP 至少需要一个url参数!');
              return _context3.abrupt('return');

            case 3:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                window.jsonCallBack = function (result) {
                  callback && callback();
                  resolve(result);
                };
                var JSONP = document.createElement("script");
                JSONP.type = "text/javascript";
                JSONP.src = url + '&callback=jsonCallBack';
                document.getElementsByTagName("head")[0].appendChild(JSONP);
                setTimeout(function () {
                  document.getElementsByTagName("head")[0].removeChild(JSONP);
                }, 500);
              }));

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/weixin-js-sdk/index.js
var weixin_js_sdk = __webpack_require__("fxnj");
var weixin_js_sdk_default = /*#__PURE__*/__webpack_require__.n(weixin_js_sdk);

// EXTERNAL MODULE: ./src/conf/index.js
var conf = __webpack_require__("1QOn");

// EXTERNAL MODULE: ./src/utils/http.js
var http = __webpack_require__("3pLw");

// EXTERNAL MODULE: ./src/vuex/state.js
var state = __webpack_require__("yalW");

// EXTERNAL MODULE: ./src/utils/storage.js
var storage = __webpack_require__("VKKs");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__("mw3O");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue


//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var App = ({
  name: "app",
  data: function data() {
    return {
      wxconfig: {
        appId: "",
        timestamp: "",
        nonceStr: "",
        signature: ""
      },
      locationUrl: "",
      shareUrl: "", // 分享链接
      shareTitle: "意礴定制商城", // 分享标题
      shareDesc: "舒适不将就，为你定制专属鞋款！", // 分享描述
      shareImgUrl: conf["a" /* default */].domainname + "/static/img/epoqueLogo.jpg" // 分享图标
    };
  },

  components: {
    // loads,
  },
  methods: {
    // 跳转article时先获取数据 n
    getArticleApiDetails: function getArticleApiDetails(id, callback) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var self, res;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;
                // 弹窗进入的时候传issue_status=2，其他为1

                _context.next = 3;
                return http["a" /* default */].post("/v1/special/detail", { special_page: id });

              case 3:
                res = _context.sent;

                self.$store.state.articleApiDetails = res;
                callback(res);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getweinsdkinfo: function getweinsdkinfo() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var self, res;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = _this2;
                _context2.next = 3;
                return http["a" /* default */].post("/v1/js.conf", { url: self.locationUrl });

              case 3:
                res = _context2.sent;

                if (res.code == 200) {
                  self.wxconfig.appId = res.data.appId;
                  self.wxconfig.timestamp = res.data.timestamp;
                  self.wxconfig.nonceStr = res.data.nonceStr;
                  self.wxconfig.signature = res.data.signature;
                  if (self.$route.path == "/article") {
                    self.getArticleApiDetails(self.$route.query.specialId, function (res) {
                      self.init();
                    });
                  } else {
                    self.init();
                  }
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },

    init: function init() {
      var self = this;
      weixin_js_sdk_default.a.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: self.wxconfig.appId, // 必填，公众号的唯一标识
        timestamp: self.wxconfig.timestamp, // 必填，生成签名的时间戳
        nonceStr: self.wxconfig.nonceStr, // 必填，生成签名的随机串
        signature: self.wxconfig.signature, // 必填，签名，见附录1
        jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline", "scanQRCode", "updateTimelineShareData", "updateAppMessageShareData"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.updateTimelineShareData({
          title: self.shareTitle, // 分享标题
          desc: self.shareDesc, // 分享描述
          link: self.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: self.shareImgUrl, // 分享图标
          success: function success() {
            // 用户确认分享后执行的回调函数
          },
          cancel: function cancel() {
            // 用户取消分享后执行的回调函数
          }
        });
        //分享给朋友
        weixin_js_sdk_default.a.updateAppMessageShareData({
          title: self.shareTitle, // 分享标题
          desc: self.shareDesc, // 分享描述
          link: self.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: self.shareImgUrl, // 分享图标
          type: "", // 分享类型,music、video或link，不填默认为link
          dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
          success: function success(e) {},
          cancel: function cancel(e) {
            // 用户取消分享后执行的回调函数
            alert("cancel,取消分享");
            alert(e);
          },
          catch: function _catch(e) {
            alert("catch,分享失败");
            alert(e);
          },
          error: function error() {
            alert("error,分享信息错误");
            alert(e);
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
          location.reload();
        }
      });
      weixin_js_sdk_default.a.checkJsApi({
        jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage", "scanQRCode", "updateTimelineShareData", "updateAppMessageShareData"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function success(res) {}
      });
    }
  },
  watch: {
    $route: function $route(to, from) {
      var self = this;
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        self.locationUrl = location.href;
      } else if (isIOS) {
        self.locationUrl = location.href.split("#")[0]; //hash后面的部分如果带上ios中config会不对
      } else {
        self.locationUrl = location.href.split("#")[0];
      }
      if (to.path.indexOf("detailsofthebnedition") > -1) {
        self.shareUrl = location.href.replace(/\/detailsofthebnedition\/.*?\?/, "/detailsofthebnedition?");
      } else if (to.path == "/customArea") {
        self.shareUrl = location.href;
        self.shareTitle = "意礴最全定制攻略";
        self.shareDesc = "DIY材质和配色、选尺码和宽窄，打造你的专属鞋款";
        self.shareImgUrl = conf["a" /* default */].domainname + "/static/img/epoqueLogo.jpg";
      } else if (to.path == "/activity") {
        // 请求的
        // console.log('activity')
        self.shareUrl = location.href;
        var shareTitle = self.$store.state.detailApiDetails ? self.$store.state.detailApiDetails.share_title : storage["a" /* default */].get("activityShareTitle");
        var shareDesc = self.$store.state.detailApiDetails ? self.$store.state.detailApiDetails.share_describe : storage["a" /* default */].get("activityShareDescribe");
        var shareImgUrl = self.$store.state.detailApiDetails ? self.$store.state.detailApiDetails.share_image : storage["a" /* default */].get("activityShareImage");
        self.shareTitle = shareTitle;
        self.shareDesc = shareDesc;
        self.shareImgUrl = shareImgUrl;
      } else if (to.path == "/article") {
        // 请求的
        self.shareUrl = location.href;
        var _shareTitle = self.$store.state.articleApiDetails ? self.$store.state.articleApiDetails.share_title : storage["a" /* default */].get("articleShareTitle");
        var _shareDesc = self.$store.state.articleApiDetails ? self.$store.state.articleApiDetails.share_describe : storage["a" /* default */].get("articleShareDescribe");
        var _shareImgUrl = self.$store.state.articleApiDetails ? self.$store.state.articleApiDetails.share_image : storage["a" /* default */].get("articleShareImage");
        self.shareTitle = _shareTitle;
        self.shareDesc = _shareDesc;
        self.shareImgUrl = _shareImgUrl;
      } else if (to.path == "/getticket") {
        axios_default.a.post("/v1/special/detail", {
          special_page: to.query.specialId
        }).then(function (res) {
          if (res.data.share_describe) {
            self.shareTitle = res.data.share_title;
            self.shareDesc = res.data.share_describe;
            self.shareImgUrl = res.data.share_image;
          }
        });
      } else if (to.path == "/coupondetailr" || to.path == "/couponReceive") {
        // 请求的
        var showName = encodeURI(to.query.showName);
        if (!to.query.couponType) {
          self.shareUrl = conf["a" /* default */].domainname + "/#/couponReceive?recordId=" + to.query.recordId + "&showName=" + showName + "&parValue=" + to.query.parValue;
          self.shareTitle = "\u9001\u4F60\u4E00\u5F20" + (to.query.parValue - 0) + "\u5143" + decodeURI(showName);
        } else {
          self.shareUrl = conf["a" /* default */].domainname + "/#/couponReceive?recordId=" + to.query.recordId + "&showName=" + showName + "&parValue=" + to.query.parValue + "&couponType=3";
          self.shareTitle = "\u9001\u4F60\u4E00\u5F20" + (to.query.parValue - 0) / 10 + "\u6298" + decodeURI(showName);
        }
        self.shareDesc = "\u8212\u9002\u4E0D\u5C06\u5C31\uFF0C\u4E3A\u4F60\u5B9A\u5236\u4E13\u5C5E\u978B\u6B3E!";
        self.shareImgUrl = conf["a" /* default */].domainname + "/static/img/epoqueLogo.jpg";
      } else {
        self.shareUrl = "" + conf["a" /* default */].domainname;
        self.shareTitle = "意礴定制商城";
        self.shareDesc = "舒适不将就，为你定制专属鞋款！";
        self.shareImgUrl = conf["a" /* default */].domainname + "/static/img/epoqueLogo.jpg";
      }
      if (localStorage.getItem("epoqueToken") && localStorage.getItem("epoqueToken") != "") {
        this.getweinsdkinfo();
      }
    }
  },
  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc839aa6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":_vm.$store.state.includedComponents,"exclude":_vm.$store.state.excludedComponents}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MN+h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./src/utils/storage.js
var storage = __webpack_require__("VKKs");

// EXTERNAL MODULE: ./src/router/index.js
var router = __webpack_require__("YaEn");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/transfer.vue

//
//
//
//
//
//




/* harmony default export */ var transfer = ({
  name: 'transfer',
  data: function data() {
    return {
      membersign: '',
      referer: ''
      // isnew:'',
    };
  },
  created: function created() {
    var self = this;
    var urlparam = self.$route.query;
    self.membersign = urlparam.membersign;
  },
  mounted: function mounted() {
    // alert('is in transfer')
    // this.gettoken();
    // console.log(location.origin)
    // if(storage.get('masterPartnerUrlVal')){
    //   let url = storage.get('masterPartnerUrlVal')
    //   storage.remove('masterPartnerUrl')
    //   // alert(storage.get('masterPartnerUrl').split('/#')[1])
    //   // window.location.replace(storage.get('masterPartnerUrl'))
    //   // alert(url.split('/#')[1])
    //   this.$router.replace(url.split('/#')[1])
    // }
  },

  methods: {
    gettoken: function gettoken() {
      var self = this;
      // alert('66')
      axios_default.a.post('/v1/user/token/get', {
        member_sign: self.membersign
      }).then(function (res) {
        if (res.data.code == 200) {
          var token = res.data.data.token;
          //新获取的token  7天后过期
          var expiredTime = new Date().getTime() + 25200000,
              epoqueToken = { "content": token, "expiredTime": expiredTime };
          localStorage.setItem("epoqueToken", stringify_default()(epoqueToken));
          store.state.islogin = res.data.data.is_new;
          store.state.referer = res.data.data.referer;
          if (res.data.data.referer == '') {
            // alert('7')
            referer = "/";
          } else {
            // alert('8')
            referer = res.data.data.referer;
          }
          //去掉重定向后的时间戳
          location.replace(location.protocol + '//' + location.host + '/#' + referer);
        }
      });
    }
  },
  route: {
    canReuse: false
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-594379aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/transfer.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_transfer = (esExports);
// CONCATENATED MODULE: ./src/components/common/transfer.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  transfer,
  common_transfer,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_transfer = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_state__ = __webpack_require__("yalW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__conf__ = __webpack_require__("1QOn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_lazyload__ = __webpack_require__("cTzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_lazyload__);









__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_lazyload___default.a, {
  error: './static/img/lazyload_fail.png',
  loading: './static/img/lazyload.png',
  attempt: 3
});

__WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.baseURL = '' + __WEBPACK_IMPORTED_MODULE_6__conf__["a" /* default */].router;
__WEBPACK_IMPORTED_MODULE_5_axios___default.a.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  // var epoqueToken = sessionStorage.getItem('epoqueToken');
  if (localStorage.epoqueToken) {
    config.headers['X-epoque-mall-Authorization'] = JSON.parse(localStorage.epoqueToken).content;
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});
__WEBPACK_IMPORTED_MODULE_5_axios___default.a.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  if (response.data.error_code && (response.data.error_code == 10001 || response.data.error_code == 10002)) {
    localStorage.removeItem('epoqueToken'); //新加的
    location.reload(true);
  }
  return response;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;
var vm = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__vuex_state__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  mounted: function mounted() {}
});

/***/ }),

/***/ "VKKs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  set: function set(name, content) {
    if (!name) {
      return;
    }
    if (typeof content !== 'string') {
      content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content);
    }
    window.sessionStorage.setItem(name, content);
  },
  get: function get(name) {
    if (!name) {
      return;
    }
    return window.sessionStorage.getItem(name);
  },
  remove: function remove(name) {
    if (!name) {
      return;
    }
    window.sessionStorage.removeItem(name);
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_state__ = __webpack_require__("yalW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_transfer__ = __webpack_require__("MN+h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__conf__ = __webpack_require__("1QOn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_storage__ = __webpack_require__("VKKs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_http__ = __webpack_require__("3pLw");





var _this = this;






 // 路由中转






__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]);

// 页面信息对象
var sourceObj = {
  productindexType: 1,
  productindexName: '首页',
  searchType: 2,
  searchName: '搜索',
  listSearchType: 3,
  listSearchName: '搜索列表',
  articleType: 4,
  articleName: '文章页',
  activityType: 5,
  activityName: '落地页',
  getticketType: 6,
  getticketName: '券提取页',
  person_centerType: 7,
  person_centerName: '个人中心',
  productlistDiyType: 8,
  productlistDiyName: '商品列表DIY配色',
  productlistDisplayWindowType: 9,
  productlistDisplayWindowName: '商品列表橱窗',
  productlistDisplayWindowBrandType: 10,
  productlistDisplayWindowBrandName: '商品列表入驻品牌',
  detailsofthebneditionType: 11,
  detailsofthebneditionName: '商品详情',
  detailSkuType: 11,
  detailSkuName: '商品详情',
  detailCouponNullType: 11,
  detailCouponNullName: '商品详情',
  subordbneditionType: 12,
  subordbneditionName: '确认订单',
  paystatusinshopType: 13,
  paystatusinshopName: '支付状态',
  paystatusType: 13,
  paystatusName: '支付状态',
  orderdetailType: 14,
  orderdetailName: '订单详情',
  orderlistType: 15,
  orderlistName: '订单列表',
  exclusiveRecommendationType: 16,
  exclusiveRecommendationName: '专属推荐',
  collectType: 17,
  collectName: '商品收藏'
  // 返回页面信息
};var returnSourceObj = function returnSourceObj(name) {
  if (name && sourceObj[name]) {
    return sourceObj[name];
  }
  return name;
};

// 设置本地页面信息
var setInfo = function setInfo(previousType, previousName, previousMainParam) {
  var previousOtherParam = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  previousType == 'remove' ? __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].remove('previousType', previousType) : previousType != 'self' ? __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].set('previousType', previousType) : '';
  previousName == 'remove' ? __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].remove('previousName', previousName) : previousName != 'self' ? __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].set('previousName', previousName) : '';
  previousMainParam == 'remove' ? __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].remove('previousMainParam', previousMainParam) : previousMainParam != 'self' ? __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].set('previousMainParam', previousMainParam) : '';
  previousOtherParam.length != 0 ? previousOtherParam == 'remove' ? __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].remove('previousOtherParam', previousOtherParam) : previousOtherParam != 'self' ? __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].set('previousOtherParam', previousOtherParam) : '' : '';
};

// 返回类型和页面名
var returnPageOrTypeName = function returnPageOrTypeName(name) {
  if (name && sourceObj[name]) {
    return sourceObj[name];
  }
  return;
};

var router = new __WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */], // 顶层路由
    children: [// 二级路由
    // 地址为空跳转productIndex页面
    {
      path: '',
      redirect: '/productindex'
    }, {
      path: '/productindex',
      name: 'productindex',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("iVAe")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '意礴定制商城'
      },
      children: []
    }, {
      path: 'search',
      name: 'search',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(39)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("X5uk")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '首页_搜索'
      }
    },
    // 首页搜索结果列表
    {
      path: 'listSearch',
      name: 'listSearch',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("z10w")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '搜索列表'
      }
    },
    // 中转路由
    {
      path: '/transfer',
      name: 'transfer',
      component: function component(resolve) {
        return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MN+h")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      } // 中转组件
    }, {
      path: '/person_center',
      name: 'person_center',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("UDoS")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '个人中心'
      }
    }, {
      path: '/submitorder',
      name: 'submitorder',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9mge")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '提交订单'
      }
    }, {
      path: '/submitordernocustom',
      name: 'submitordernocustom',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(44)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("u5oO")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '提交订单'
      }
    }, {
      path: '/subordbnedition',
      name: 'subordbnedition',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("DdIi")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '提交订单'
      },
      children: [{
        path: 'preferenceAcquisition',
        name: 'preferenceAcquisition',
        component: function component(resolve) {
          return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("45HA")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
      }]
    }, {
      path: '/orderdetail',
      name: 'orderdetail',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2yPk")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '订单详情'
      }
    }, {
      path: '/debugpages',
      name: 'debugpages',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("U2rP")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '确认订单地址'
      }
    }, {
      path: '/commoditydetail',
      name: 'commoditydetail',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("if66")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '商品详情'
      }
    }, {
      path: '/commoditydetailnocustom',
      name: 'commoditydetailnocustom',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("epJZ")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '商品详情'
      }
    }, {
      path: '/detailsofthebnedition',
      name: 'detailsofthebnedition',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("X7HV")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '商品详情'
      },
      children: [{
        path: '',
        name: 'detailCouponNull',
        component: function component(resolve) {
          return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(53)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("riEQ")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
          title: '商品详情'
        }
      }, {
        path: 'detailCoupon',
        name: 'detailCoupon',
        component: function component(resolve) {
          return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(29)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("PEg2")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
          title: '商品详情'
        }
      }, {
        path: 'detailSku',
        name: 'detailSku',
        component: function component(resolve) {
          return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(33)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("nUX0")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: {
          title: '商品详情'
        }
      }]
    }, {
      path: '/addresslist',
      name: 'addresslist',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(38)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Mnwi")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      props: true,
      meta: {
        title: '地址列表'
      }
    }, {
      path: '/editaddress/:id',
      name: 'editaddress',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("AqRF")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      props: true,
      meta: {
        title: '编辑地址'
      }
    }, {
      path: '/customexplain',
      name: 'customexplain',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(36)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/GAm")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '定制说明'
      }
    }, {
      path: '/paystatus',
      name: 'paystatus',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(34)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dIco")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '支付状态'
      }
    }, {
      path: '/paystatusinshop',
      name: 'paystatusinshop',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(45)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("h4C0")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '支付状态'
      }
    }, {
      path: '/productlist',
      name: 'productlist',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("P3/l")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      props: true,
      meta: {
        title: '商品列表'
      }
    }, {
      path: '/productlistnull',
      name: 'productlistnull',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(54)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GLwv")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      props: true,
      meta: {
        title: '商品列表'
      }
    }, {
      path: '/passportlist',
      name: 'passport_list',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("22R+")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '报告列表'
      }
    }, {
      path: '/passportdetail/:center/:uuid',
      name: 'passportdetail',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XEcb")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      props: true
    }, {
      path: '/passportdetail',
      name: 'passport_detail',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XEcb")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '报告详情'
      }
    }, {
      path: '/data_validation',
      name: 'data_validation',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(47)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ZnWL")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '足型数据确认'
      }
    }, {
      path: '/footcomfir',
      name: 'footcomfir',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("vVQF")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '确认报告'
      }
    }, {
      path: '/personaldata',
      name: 'personal_data',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(25)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ql1G")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '修改资料'
      }
    }, {
      path: '/coupon/:type',
      name: 'coupon',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("d6N+")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      props: true,
      meta: {
        title: '优惠劵'
      }
    }, {
      path: '/orderlist',
      name: 'orderlist',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("3qvc")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }, // 订单列表
      meta: {
        title: '我的订单'
      }
    }, {
      path: '/orderdelivery',
      name: 'orderdelivery',
      // component: orderdelivery,
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1bYt")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }, // 订单列表
      meta: {
        title: '订单跟踪'
      }
    }, {
      path: '/verify',
      name: 'verify',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(57)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Y+Hx")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '验证手机号'
      }
    }, {
      path: '/coupondetail',
      name: 'coupon_detail',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(49)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mPh3")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      props: true,
      meta: {
        title: '优惠券详情'
      }
    }, {
      path: '/coupondetailr',
      name: 'coupon_detail_r',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(48)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("fswn")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      props: true,
      meta: {
        title: '优惠券详情'
      }
    }, {
      path: '/couponReceive',
      name: 'couponReceive',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Pe7l")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      props: true,
      meta: {
        title: '领取优惠券'
      }
    }, {
      path: '/orderevaluate',
      name: 'orderevaluate',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(50)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Bdxw")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }, // 订单评价
      meta: {
        title: '订单评价'
      }
    },
    /*售后*/
    //售后生成
    {
      path: '/saleservicegenerate',
      name: 'saleservicegenerate',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("iDHa")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }, // 售后生成
      meta: {
        title: '售后生成'
      }
    },
    //售后政策
    {
      path: '/saleservicepolicy',
      name: 'saleservicepolicy',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(42)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ABfy")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }, //售后政策
      meta: {
        title: '售后政策'
      }
    },
    // 售后列表
    {
      path: '/saleservicelist',
      name: 'saleservicelist',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jdZq")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }, // 售后列表
      meta: {
        title: '售后列表'
      }
    },
    // 售后详情
    {
      path: '/saleserviceinfo',
      name: 'saleserviceinfo',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(32)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("sPNh")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }, // 售后详情
      meta: {
        title: '售后详情'
      }
    },

    //售后审核成功
    {
      path: '/saleservicesuccess',
      name: 'saleservicesuccess',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(31)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("C+eb")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }, //审核成功
      meta: {
        title: '审核成功'
      }
    },
    // 审核失败
    {
      path: '/saleservicefail',
      name: 'saleservicefail',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(52)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+LH8")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }, //审核失败
      meta: {
        title: '审核失败'
      }
    },
    //售后关闭
    {
      path: '/saleserviceclose',
      name: 'saleserviceclose',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(43)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GK03")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }, //售后关闭
      meta: {
        title: '售后关闭'
      }
    },

    //物流
    {
      path: '/saleservicelogistics',
      name: 'saleservicelogistics',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ScLh")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }, //物流
      meta: {
        title: '物流信息'
      }
    },
    //工厂已收货
    {
      path: '/saleservicereceive',
      name: 'saleservicereceive',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(41)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8N0P")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      } //工厂已收货
    },
    //售后退款
    {
      path: '/saleservicerefund',
      name: 'saleservicerefund',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(40)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("c78b")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }, //退款
      meta: {
        title: '售后退款'
      }
    },
    //下拉加载测试
    {
      path: '/list',
      name: 'list',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(55)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eP2p")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      } //下拉加载测试
    },
    //小编推荐
    {
      path: '/article',
      name: 'article',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(56)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QgFn")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '小编推荐'
      }
    },
    // 活动专题页
    {
      path: '/activity',
      name: 'activity',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("deAk")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '活动专题页'
      }
    }, {
      path: '/getticket',
      name: 'getticket',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(35)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("LK+I")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '券提取页'
      }
    },

    // 专题定制页
    {
      path: '/customArea',
      name: 'customArea',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("IppG")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      } //活动专题页
    },
    // 我的专属推荐页
    {
      path: '/exclusiveRecommendation',
      name: 'exclusiveRecommendation',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("vMmg")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    },
    //指引页面
    // 失效页面
    {
      path: '/pageFailure',
      name: 'pageFailure',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(51)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("U48C")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    },
    // 合伙人简介
    {
      path: '/partner',
      name: 'partner',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(37)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("TUKF")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    },
    // 合伙人优惠券领取
    {
      path: '/partnerCoupon',
      name: 'partnerCoupon',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(46)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("nKrl")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    },
    // 合伙人优惠券领取
    {
      path: '/getpartnercoupon',
      name: 'getpartnerCoupon',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("3WJD")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    },
    // 商品收藏
    {
      path: '/collect',
      name: 'collect',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(27)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wQdw")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    },
    // 活动 - 鞋款测评 投票
    {
      path: '/vote',
      name: 'vote',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ZN53")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '鞋款评测'
      }
    },
    // 活动 - 鞋款测评 抽奖 送券
    {
      path: '/wheel',
      name: 'wheel',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("LAH0")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        title: '鞋款评测'
      }
    }]
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

var getToken = function getToken(to) {
  var referer;
  __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post('/v1/user/token/get', {
    member_sign: to.query.membersign
  }).then(function (res) {
    if (res.data.code == 200) {
      var token = res.data.data.token;
      //新获取的token  7天后过期
      var expiredTime = new Date().getTime() + 25200000,
          epoqueToken = { "content": token, "expiredTime": expiredTime };
      localStorage.setItem("epoqueToken", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(epoqueToken));
      __WEBPACK_IMPORTED_MODULE_7__vuex_state__["a" /* default */].state.islogin = res.data.data.is_new;
      __WEBPACK_IMPORTED_MODULE_7__vuex_state__["a" /* default */].state.referer = res.data.data.referer;
      // console.log(res.data.data)
      // console.log(res.data.data.referer.indexOf('masterPartner=') != -1)
      if (res.data.data.referer == '') {
        referer = "/";
      } else if (res.data.data.referer.indexOf('masterPartner=') != -1) {
        // referer = res.data.data.referer
        if (res.data.data.referer.indexOf('?masterPartner=') != -1) {
          if (res.data.data.referer.indexOf('&') != -1) {
            referer = res.data.data.referer.replace(/masterPartner=.*?\&/, '');
            // storage.set('masterPartnerUrl', res.data.data.referer.replace(/masterPartner=.*?\&/, ''))
          } else {
            referer = res.data.data.referer.split('?masterPartner=')[0];
            // storage.set('masterPartnerUrl', res.data.data.referer.split('?masterPartner=')[0])
          }
        } else if (res.data.data.referer.indexOf('&masterPartner=') != -1) {
          var length = res.data.data.referer.split('&masterPartner=')[1].split('&').length;
          if (length > 1) {
            referer = res.data.data.referer.replace(/\&masterPartner=.*?(?=\&)/, '');
            // storage.set('masterPartnerUrl', res.data.data.referer.replace(/\&masterPartner=.*?(?=\&)/, ''))
          } else {
            referer = res.data.data.referer.split('&masterPartner=')[0];
            // storage.set('masterPartnerUrl', res.data.data.referer.split('&masterPartner=')[0])
          }
        }
      } else {
        referer = res.data.data.referer;
      }
      __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('loginfirst') && __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].remove('loginfirst');
      //去掉重定向后的时间戳
      location.replace(location.protocol + '//' + location.host + '/#' + referer);
    } else {
      setTimeout(function () {
        var transferUrl = encodeURI(location.origin + "/@/transfer");
        var refererUrl = encodeURIComponent(to.fullPath);
        window.location.replace(__WEBPACK_IMPORTED_MODULE_9__conf__["a" /* default */].routerapi + '?transfer=' + transferUrl + '&referer=' + refererUrl);
      }, 100);
    }
  }).catch(function (error) {
    console.log(error);
  });
};

// 返回字符串形式的数组或空
var returnArrStr = function returnArrStr() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (arr.length) {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(arr);
  }
  return;
};
var currentOtherParam = []; // 当前页剩余参
var previousOtherParam = []; // 当前页剩余参
var a = 'null',
    b = 'null',
    c = 'null',
    d = 'null',
    e = 'null',
    f = 'null',
    g = 'null',
    h = 'null'; // a = currentType, b = currentName, c = currentMainParam, d = currentOtherParam, evaluation = previousType, f = previousName, g = previousMainParam, h = previousOtherParam
// 传输页面信息, 有传参的使用传参，否则使用sessionStorage存储的
var transmitInformation = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(callback, a1, b1, c1, d1, e1, f1, g1, h1) {
    var a, b, c, d, e, f, g, h, res;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            a = void 0, b = void 0, c = void 0, d = void 0, e = void 0, f = void 0, g = void 0, h = void 0;

            if (a1) {
              a1 != 'null' ? a = a1 : '';
            } else {
              a = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('currentType');
            }
            if (b1) {
              b1 != 'null' ? b = b1 : '';
            } else {
              b = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('currentName');
            }
            if (c1) {
              c1 != 'null' ? c = c1 : '';
            } else {
              c = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('currentMainParam');
            }
            if (d1) {
              d1 != 'null' ? d = d1 : '';
            } else {
              d = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('currentOtherParam');
            }
            if (e1) {
              e1 != 'null' ? e = e1 : '';
            } else {
              e = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousType');
            }
            if (f1) {
              f1 != 'null' ? f = f1 : '';
            } else {
              f = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousName');
            }
            if (g1) {
              g1 != 'null' ? g = g1 : '';
            } else {
              g = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousMainParam');
            }
            if (h1) {
              h1 != 'null' ? h = h1 : '';
            } else {
              h = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousOtherParam');
            }
            _context.next = 11;
            return __WEBPACK_IMPORTED_MODULE_13__utils_http__["a" /* default */].post('/v1/user/op/log', {
              previous_type: e,
              previous_name: f,
              previous_main_param: g,
              previous_other_params: h,
              current_type: a,
              current_name: b,
              current_main_param: c,
              current_other_params: d
            });

          case 11:
            res = _context.sent;

            callback && callback(res);

          case 13:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function transmitInformation(_x3, _x4, _x5, _x6, _x7, _x8, _x9, _x10, _x11) {
    return _ref.apply(this, arguments);
  };
}();

router.beforeEach(function (to, from, next) {
  currentOtherParam = []; // 当前页剩余参
  previousOtherParam = []; // 当前页剩余参
  a = 'null';
  b = 'null';
  c = 'null';
  d = 'null';
  e = 'null';
  f = 'null';
  g = 'null';
  h = 'null';
  if (to.query.membersign) {
    // 有membersign
    getToken(to, from, next);
  } else if (to.query.masterPartner) {
    // 从合伙人过来
    __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].set('masterPartnerUrl', to.query.masterPartner);
    __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].set('materNo', to.query.materNo);
    getToken(to, from, next);
  } else {
    // 无membersign
    if (localStorage.epoqueToken) {
      // 有token
      try {
        JSON.parse(localStorage.epoqueToken).content;
      } catch (err) {
        window.localStorage.removeItem("epoqueToken");
        location.reload();
      }
      var currentTime = new Date().getTime(),
          epoqueToken = JSON.parse(localStorage.epoqueToken);
      if (epoqueToken.expiredTime - currentTime < 0 && __WEBPACK_IMPORTED_MODULE_7__vuex_state__["a" /* default */].state.loginfirst) {
        //删除token
        localStorage.removeItem("epoqueToken");
        //重新获取token跳授权
        setTimeout(function () {
          var transferUrl = encodeURI(location.origin + "/@/transfer");
          var refererUrl = encodeURIComponent(to.fullPath);
          window.location.replace(__WEBPACK_IMPORTED_MODULE_9__conf__["a" /* default */].routerapi + '?transfer=' + transferUrl + '&referer=' + refererUrl);
        }, 100);
      } else {
        if (!from.name) {
          if (__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('masterPartnerUrl')) {
            currentOtherParam.push('masterPartner: ' + __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('masterPartnerUrl'));
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(from.query).map(function (value, index) {
            previousOtherParam.push(value[0] + ': ' + value[1]);
          });
          e = returnPageOrTypeName(from.name + 'Type');
          f = returnPageOrTypeName(from.name + 'Name');
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(to.query).map(function (value, index) {
          currentOtherParam.push(value[0] + ': ' + value[1]);
        });
        a = returnPageOrTypeName(to.name + 'Type');
        b = returnPageOrTypeName(to.name + 'Name');
        if (to.path == '/productindex') {
          if (currentOtherParam[0] && currentOtherParam[0].match('masterPartner')) {
            c = currentOtherParam[0];
          }
          if (previousOtherParam[0] && (previousOtherParam[0].match('id') || previousOtherParam[0].match('Id'))) {
            g = previousOtherParam[0];
          }
          transmitInformation(function () {}, a, b, c, d, e, f, g, h);
        } else if (to.path == '/productlist') {
          if (to.query.source == 'diy') {
            a = 8;
            b = '商品列表diy';
          } else if (to.query.brandId) {
            a = 10;
            b = '商品列表品牌';
            c = 'brandNo: ' + to.query.brandId;
          } else if (to.query.source == 'displayWindow') {
            a = 9;
            b = '商品列表橱窗';
            c = 'shopwindowId: ' + __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('shopwindowId');
          }
          transmitInformation(function () {}, a, b, c, d, e, f, g, h);
        } else if (to.path == '/detailsofthebnedition') {
          var tradeName = JSON.parse(__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('tradeName'));
          c = currentOtherParam[0];
          if (from.path != '/detailsofthebnedition/detailSku' && from.path != '/detailsofthebnedition/detailCoupon') {
            if (from.path == '/productlist') {
              if (from.query.source == 'diy') {
                e = 8;
                f = '商品列表diy';
                setInfo(e, f, '', '');
              } else if (from.query.brandId) {
                e = 10;
                f = '商品列表品牌';
                g = 'brandNo: ' + from.query.brandId;
                setInfo(e, f, g, '');
              } else if (from.query.source == 'displayWindow') {
                e = 9;
                f = '商品列表橱窗';
                g = 'shopwindowId: ' + __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('shopwindowId');
                setInfo(e, f, g, '');
              }
            } else if (from.path == '/productindex') {
              e = 1;
              f = '首页';
              setInfo(e, f, '', '');
            } else if (from.path == '/listSearch') {
              e = 3;
              f = '搜索列表';
              if (__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousMainParam')) {
                g = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousMainParam');
              }
              if (__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousOtherParam')) {
                h = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousOtherParam');
              }
              setInfo(e, f, g, h);
            } else if (from.path == '/subordbnedition') {
              g = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousMainParam');
            } else if (from.path == '/paystatusinshop') {
              g = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousMainParam');
            } else if (from.path == '/orderdetail') {
              g = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousMainParam');
            } else if (from.path == '/exclusiveRecommendation') {
              e = 16;
              f = '专属推荐';
              setInfo(e, f, g, h);
            } else if (from.path == '/collect') {
              e = 17;
              f = '商品收藏';
              setInfo(e, f, g, h);
            }
            transmitInformation(function () {}, a, b, c, d, e, f, g, h);
          }
        } else if (to.path == '/subordbnedition') {
          c = 'commodityId: ' + to.query.commodityId;
          // if(storage.get('currentMainParam')){
          //   c = storage.get('currentMainParam')
          // }
          // if(storage.get('currentOtherParam')){
          //   d = storage.get('currentOtherParam')
          // }

          if (__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousType')) {
            e = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousType');
          }
          if (__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousName')) {
            f = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousName');
          }
          if (__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousMainParam')) {
            g = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousMainParam');
          }
          if (__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousOtherParam')) {
            h = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousOtherParam');
          }
          transmitInformation(function () {}, a, b, c, d, e, f, g, h);
        } else if (to.path == '/paystatusinshop' || to.path == '/paystatus') {
          if ((from.path == '/subordbnedition' || from.path == '/orderlist' || from.path == '/orderdetail') && __WEBPACK_IMPORTED_MODULE_7__vuex_state__["a" /* default */].state.normalPay == 1) {
            if (to.path == '/paystatusinshop' || to.query.paystatus && to.query.paystatus == 'true') {
              c = '支付成功';
            } else {
              c = '支付错误';
            }
            var dArr = [];
            dArr.push(currentOtherParam[1]);
            d = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(dArr);
            if (__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousType') && from.path == '/subordbnedition') {
              e = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousType');
            }
            if (__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousName') && from.path == '/subordbnedition') {
              f = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousName');
            }
            if (__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousMainParam') && from.path == '/subordbnedition') {
              g = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousMainParam');
            } else {
              g = currentOtherParam[1];
            }
            if (__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousOtherParam') && from.path == '/subordbnedition') {
              h = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousOtherParam');
            }
            __WEBPACK_IMPORTED_MODULE_7__vuex_state__["a" /* default */].state.normalPay = null;
            transmitInformation(function () {}, a, b, c, d, e, f, g, h);
          }
        } else if (to.path == '/orderdetail') {
          if (from.path == '/subordbnedition' || from.path == '/orderlist') {
            c = '支付关闭';
            var _dArr = [];
            _dArr.push(currentOtherParam[0]);
            d = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_dArr);
            if (__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousType')) {
              e = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousType');
            }
            if (__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousName')) {
              f = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousName');
            }
            if (__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousMainParam')) {
              g = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousMainParam');
            }
            if (__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousOtherParam')) {
              h = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('previousOtherParam');
            }
            transmitInformation(function () {}, a, b, c, d, e, f, g, h);
          }
        } else if (to.path == '/article') {
          var shareTitle = __WEBPACK_IMPORTED_MODULE_7__vuex_state__["a" /* default */].state.detailApiDetails ? __WEBPACK_IMPORTED_MODULE_7__vuex_state__["a" /* default */].state.detailApiDetails.share_title : __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('activityShareTitle');
          c = 'special_page:' + to.query.specialId;
          transmitInformation(function () {}, a, b, c, d, e, f, g, h);
        } else if (to.path == '/activity') {
          var _shareTitle = __WEBPACK_IMPORTED_MODULE_7__vuex_state__["a" /* default */].state.detailApiDetails ? __WEBPACK_IMPORTED_MODULE_7__vuex_state__["a" /* default */].state.detailApiDetails.share_title : __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('activityShareTitle');
          c = 'special_page:' + to.query.specialId;
          transmitInformation(function () {}, a, b, c, d, e, f, g, h);
        } else if (to.path == '/getticket') {
          var _shareTitle2 = __WEBPACK_IMPORTED_MODULE_7__vuex_state__["a" /* default */].state.detailApiDetails ? __WEBPACK_IMPORTED_MODULE_7__vuex_state__["a" /* default */].state.detailApiDetails.share_title : __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('activityShareTitle');
          c = 'special_page:' + to.query.specialId;
          transmitInformation(function () {}, a, b, c, d, e, f, g, h);
        } else if (to.path == '/exclusiveRecommendation') {
          c = 'uuid:' + to.query.uuid;
          transmitInformation(function () {}, a, b, c, d, e, f, g, h);
        } else if (to.path == '/collect') {
          transmitInformation(function () {}, a, b, c, d, e, f, g, h);
        }

        if (__WEBPACK_IMPORTED_MODULE_7__vuex_state__["a" /* default */].state.loginfirst && !__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('loginfirst')) {
          var masterPartner = void 0,
              materNo = void 0;
          if (__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('masterPartnerUrl')) {
            masterPartner = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('masterPartnerUrl');
          }
          if (__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('materNo')) {
            materNo = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('materNo');
          }
          __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post('/v1/user/update/status', __WEBPACK_IMPORTED_MODULE_11_qs___default.a.stringify({
            masterPartner: masterPartner,
            materNo: materNo
            // ip: returnCitySN["cip"]
          })).then(function (res) {
            if (res.data.code && res.data.code == 200) {
              __WEBPACK_IMPORTED_MODULE_7__vuex_state__["a" /* default */].state.loginfirst = false;
              __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].set('loginfirst', true);
              masterPartner = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].remove('masterPartnerUrl');
              materNo = __WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].remove('materNo');
              next();
            } else {
              setTimeout(function () {
                var transferUrl = encodeURI(location.origin + "/@/transfer");
                var refererUrl = encodeURIComponent(to.fullPath);
                window.location.replace(__WEBPACK_IMPORTED_MODULE_9__conf__["a" /* default */].routerapi + '?transfer=' + transferUrl + '&referer=' + refererUrl);
              }, 100);
            }
          });
        } else {
          if (__WEBPACK_IMPORTED_MODULE_12__utils_storage__["a" /* default */].get('masterPartnerUrl')) {
            setTimeout(function () {
              var transferUrl = encodeURI(location.origin + "/@/transfer");
              var refererUrl = encodeURIComponent(to.fullPath);
              window.location.replace(__WEBPACK_IMPORTED_MODULE_9__conf__["a" /* default */].routerapi + '?transfer=' + transferUrl + '&referer=' + refererUrl);
            }, 100);
          } else {
            next();
          }
        }
      }
    } else {
      // 无token
      setTimeout(function () {
        var transferUrl = encodeURI(location.origin + "/@/transfer");
        var refererUrl = encodeURIComponent(to.fullPath);
        window.location.replace(__WEBPACK_IMPORTED_MODULE_9__conf__["a" /* default */].routerapi + '?transfer=' + transferUrl + '&referer=' + refererUrl);
      }, 100);
    }
  }
});

router.afterEach(function (route) {
  // 从路由的元信息中获取 title 属性
  // Vue.nextTick(() => {
  //   sensors.quick("autoTrackSinglePage");
  // });
  if (route.meta.title) {
    document.title = route.meta.title;
    // 如果是 iOS 设备，则使用如下 hack 的写法实现页面标题的更新
    if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      var hackIframe = document.createElement('iframe');
      hackIframe.style.display = 'none';
      // hackIframe.src = '/robots.txt?r=' + Math.random()
      document.body.appendChild(hackIframe);
      setTimeout(function (_) {
        document.body.removeChild(hackIframe);
      }, 300);
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "yalW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");


var _state;



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var state = (_state = {
  uuid: '', //商品详情页面的uuid
  center: 0, //锦泉要的center
  sale_price: '', //鞋子的售价
  is_Edit: false, //是否制作了鞋子
  product_id: '', //产品ID
  // product_name:'',//产品名称
  // product_tag:'',//产品标签
  ftdconfir: false, //是否确认脚型数据
  explaincon: false, //商品详情页的《定制说明》
  explain: false, //提交订单页的《定制说明》
  agree_explain: false, //提交订单页的同意勾选框
  customized: {}, //定制参数
  // base_image:'',//线装图
  whiteimage: '', //线装图辅助图
  // merge_img:'',//定制帮面图数组
  passport: false, //足型报告弹出层
  custom: [], //定制参数，，，
  hasdefautaddress: false, //是否有默认地址
  defautaddress: false, //默认地址
  comfirmpass: false, //是否确认脚型数据（从接口返回的）
  business_shoes_size: null, // 下单页 用户编辑穿鞋尺码
  shoes_preference: null, // 下单页 用户编辑穿鞋偏好
  preference_desc: null, // 下单页 用户编辑穿鞋痛点


  /* 锦泉 */
  passportlistenteruuid: '',
  itemcenter: 0,
  address: {},
  centeraddress: 0,
  choisaddress: false,
  coupon: '',
  coupons: [],
  choiscoupon: false, // 是否选择了券
  ischangecoupon: false, // 是否修改了优惠券
  commoditydetailurl: null,
  tomap: false,
  istomap: 0,
  istomap2: 0,
  hasaddress: true,
  tomapstate: false,
  selectcoupon: {}, // coupon.vue里存放选中的优惠券
  orderamount: null,
  newchoiscoupon: [], //选中的劵
  couponprise: null, //折后价
  newaddress: false, // 是否是新增地址
  setA: false, // 阻止新增地址的第二次回退
  isDoubt: false, //
  editrefresh: false }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'product_id', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'showbuttom', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'storeforload', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'comSelecParameters', {
  base_image: '', //线装图
  product_name: '', //产品名称
  product_tag: '', //产品标签
  bnintrodarrvalue: '', //宽窄版的选择值key
  size_pool_num: '', //宽窄版选择的尺码
  modeissize: 0 // 类型1是在店定制0为高端定制
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'detailApiDetails', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'articleApiDetails', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'getticketApiDetails', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'toListRouter', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'exclusiveItem', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'recommendScore', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'includedComponents', ['productindexnull', 'productlist', 'search', 'listSearch']), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'excludedComponents', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'couponReceiveShowName', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'couponReceiveParValue', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'showreceive', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'openpurchase', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'detailCouponScrollT', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'showToCouponType', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'loginfirst', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'islogin', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'shopname', "意礴定制商城"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'referer', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'sex', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'categoryId', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'tagId', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'num', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'linkway', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'applyreason', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'saleserviceimg', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'scrollx', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'scrolly', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'popupwindow', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'scrolltoplisttodetail', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'xx', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'searchClassificationConfCate', {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'includedComponentsSearch', ['search']), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'excludedComponentsSearch', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'useDiscountType', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'transmitInformationParms', {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'normalPay', null), _state);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: state
}));

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.32422e47d521b033c8431686726335933.js